<template>
    <div>
        <el-select v-model="temp" clearable filterable placeholder="单位工程">
            <el-option :value="item" v-for="(item,index) in dwgcs" :key="index"></el-option>
        </el-select>
    </div>
</template>
<script>
    export default {
        props: {
            value: {}
        },
        data() {
            return {
                temp: '',
            }
        },
        computed: {
            dwgcs() {
                let res = [];
                this.vuex_admin.pro.items.map(item => {
                    res.push(item.title);
                });
                res.push('室外设施', '附属建筑及室外环境');
                return res;
            }
        },
        watch: {
            temp(val) {
                this.$emit('input', val);
            },
            value(val) {
                this.temp = val;
            }
        },
        methods: {
        }
    }
</script>
<style lang="scss" scoped>
    @import "index.scss";
</style>